module.exports = __webpack_public_path__ + "static/media/icon-dash-surveys.64937c79.png";